<template>
  <div class="list-box">
    <div class="nav gap-x-3" title="ZhangDanShouKuanList" data-title="账单收款">
      <el-input
        v-model="state.params.keywords"
        clearable
        placeholder="关键字"
        @keyup.enter="onLoad()"
        @clear="onLoad()"
      >
        <template #suffix>
          <el-icon
            @click="onLoad()"
            color="#a2a2a2"
            title="搜索"
            class="font-bold cursor-pointer hover:opacity-60"
            ><Search
          /></el-icon>
        </template>
      </el-input>
    </div>
    <div class="content c-table-box mt-2 bg-white rounded-lg p-2.5">
      <el-table
        :data="state.list_data"
        v-loading="!Array.isArray(state.list_data)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        ref="tableDom"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="#"
          width="70"
          type="index"
          :index="
            (index) =>
              $buildTabIndex(state.params.page, state.params.limit, index)
          "
          align="center"
        />
        <el-table-column>
          <template #header>
            <div class="c-table-col-header" label1="名称" label2="所属甲方" />
          </template>
          <template #default="{ row }">
            <c_tabgroup :value1="row.name">
              <template #bottom>
                <text>{{ row.customer?.name }}</text>
                <text class="text-xs text-gray-400">{{
                  row.customer?.number
                }}</text>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column :width="300">
          <template #header>
            <div class="c-table-col-header" label1="所属会议" label2="地址" />
          </template>
          <template #default="{ row }">
            <c_tabgroup :value2="row.meeting?.address">
              <template #top>
                <div class="flex gap-x-2">
                  <text>{{ row.meeting?.name }}</text>
                  <text>{{ "[" + row.meeting?.number + "]" }}</text>
                  <c_status
                    arrName="Meeting_Status"
                    showBg
                    :value="row.status"
                    class="m-auto"
                    :key="row.status"
                  />
                </div>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column label="负责人">
          <template #default="{ row }">
            <div class="flex gap-x-2 items-center">
              <text>{{ row.add_admin_name }}</text>
              <text class="text-xs text-gray-400">{{
                row.add_department_name
              }}</text>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="amount"
          label="金额"
          :formatter="$tab_PriceFormat"
          align="right"
        />
        <el-table-column
          prop="collected_amount"
          label="已收"
          align="right"
          :formatter="$tab_PriceFormat"
        />
        <el-table-column
          prop="uncollected_amount"
          label="未收"
          align="right"
          :formatter="$tab_MoneyFormat"
        />
        <el-table-column label="操作" fixed="right" align="center" :width="160">
          <template #default="{ row }">
            <el-button
              type="success"
              :icon="Search"
              link
              @click.stop="
                state.selectId = row.id;
                state.showDetail = true;
              "
              >查看
            </el-button>
            <el-button
              type="primary"
              :icon="Money"
              link
              v-if="row.uncollected_amount > 0"
              @click.stop="
                state.selectId = row.id;
                state.showCollected = true;
              "
              >收款
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </div>
  </div>
  <el-dialog
    v-model="state.showCollected"
    title="账单收款"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showCollected = false;
      }
    "
    style="width: 50%"
  >
    <c_collected
      :id="state.selectId"
      @close="
        state.showCollected = false;
        onLoad();
      "
    />
  </el-dialog>
  <el-dialog
    v-model="state.showDetail"
    title="账单详情"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showDetail = false;
      }
    "
    style="width: 50%"
  >
    <c_detail
      :id="state.selectId"
      @close="
        state.showDetail = false;
        onLoad();
      "
    />
  </el-dialog>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { collectedplan_page } from "@/http/zhangdanshoukuan";

import c_collected from "./Collected.vue";
import c_detail from "./Detail.vue";

class InitFormData {
  params = {
    page: 1,
  };
}

export default {
  props: {
    meeting_id: Number,
  },
  components: { c_collected, c_detail },
  setup(props) {
    const tableDom = ref(null);
    const state = reactive({
      ...new InitFormData(),
    });
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      delete state.list_data;

      collectedplan_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list, count } = res.data?.data;
          state.list_data = list;
          state.totalCount = count;
        }
      });
    };

    return {
      state,
      props,
      tableDom,
      onLoad,
    };
  },
};
</script>

<style lang="scss" scoped></style>
